<template>
  <div class="two_graph_main w_1280">
    <div class="two_graph_bg">
      <img src="@/assets/images/home03-1.png" alt="" />
    </div>
    <div class="graph_one_box">
      <div class="chart_type_box flex_center flex_column color_fff"
        :class="chartTypeList.includes(1) ? 'fade-in' : 'fade-out'" v-if="chartTypeList.includes(1)"><img
          src="@/assets/images/chartTypeLogo1.png" alt="" />
        炼油厂自用</div>
      <img class="graph_one_img1" :class="chartTypeList.includes(1) ? 'fade-in' : 'fade-out'"
        v-if="chartTypeList.includes(1)" src="@/assets/images/homeChartLine.png" alt="" />
      <img class="graph_one_img2 cursor animate-scale-one" @mouseenter="graphEnter(1)" @mouseleave="chartLeave"
        @click="selectGraphChart(1)" src="@/assets/images/homeChartBtn.png" alt="" />

      <!-- <div class="chart_type_box2 " :class="isAnimating ? 'animate-scale-seven-small-child' : ''"
        @animationend="handleAnimationEnd" v-if="!chartTypeList.includes(1)"> <img src="@/assets/images/graphImg1.png"
          alt="" />
      </div> -->
    </div>

    <div class="graph_two_box">
      <div class="chart_type_box_two flex_center flex_column color_fff"
        :class="chartTypeList.includes(2) ? 'fade-in' : 'fade-out'" v-if="chartTypeList.includes(2)">
        <img src="@/assets/images/chartTypeLogo2.png" alt="" /> 玻璃
      </div>
      <img class="graph_two_img2 cursor animate-scale-two" @mouseenter="graphEnter(2)" @mouseleave="chartLeave"
        @click="selectGraphChart(2)" src="@/assets/images/homeChartBtn.png" alt="">

      <img class="graph_two_img1" :class="chartTypeList.includes(2) ? 'fade-in' : 'fade-out'"
        v-if="chartTypeList.includes(2)" src="@/assets/images/homeChartLine.png" alt="">

      <!-- <div class="chart_type_box_two2" :class="isAnimating ? 'animate-scale-seven-small-child' : ''"
        @animationend="handleAnimationEnd" v-if="!chartTypeList.includes(2)"> <img src="@/assets/images/graphImg2.png"
          alt="" />
      </div> -->
    </div>

    <div class="graph_three_box">
      <div class="chart_type_box_three flex_center flex_column color_fff"
        :class="chartTypeList.includes(3) ? 'fade-in' : 'fade-out'" v-if="chartTypeList.includes(3)">
        <img src="@/assets/images/chartTypeLogo3.png" alt="" /> 碳化硅
      </div>

      <img class="graph_three_img2 cursor animate-scale-three" @mouseenter="graphEnter(3)" @mouseleave="chartLeave"
        @click="selectGraphChart(3)" src="@/assets/images/homeChartBtn.png" alt="">
      <img class="graph_three_img1" :class="chartTypeList.includes(3) ? 'fade-in' : 'fade-out'"
        v-if="chartTypeList.includes(3)" src="@/assets/images/homeChartLine.png" alt="">

      <!-- <div class="chart_type_box_three2" :class="isAnimating ? 'animate-scale-seven-small-child' : ''"
        @animationend="handleAnimationEnd" v-if="!chartTypeList.includes(3)"> <img src="@/assets/images/graphImg3.png"
          alt="" />
      </div> -->
    </div>

    <div class="graph_four_box">
      <div class="chart_type_box_four flex_center flex_column color_fff"
        :class="chartTypeList.includes(4) ? 'fade-in' : 'fade-out'" v-if="chartTypeList.includes(4)">
        <img src="@/assets/images/secondIcon1.png" alt="" /> 接地极焦炭
      </div>
      <img class="graph_four_img2 cursor animate-scale-four" @click="selectGraphChart(4)"
        src="@/assets/images/homeChartBtn.png" alt="">
      <img class="graph_four_img1" :class="chartTypeList.includes(4) ? 'fade-in' : 'fade-out'"
        v-if="chartTypeList.includes(4)" src="@/assets/images/homeChartLine.png" alt="">
    </div>

    <div class="graph_five_box">
      <div class="chart_type_box_five flex_center flex_column color_fff"
        :class="chartTypeList.includes(5) ? 'fade-in' : 'fade-out'" v-if="chartTypeList.includes(5)">
        <img src="@/assets/images/secondIcon2.png" alt="" /> 石墨电极
      </div>
      <img class="graph_five_img2 cursor animate-scale-five" @click="selectGraphChart(5)"
        src="@/assets/images/homeChartBtn.png" alt="">
      <img class="graph_five_img1" :class="chartTypeList.includes(5) ? 'fade-in' : 'fade-out'"
        v-if="chartTypeList.includes(5)" src="@/assets/images/homeChartLine.png" alt="">
    </div>

    <div class="graph_six_box">
      <div :class="{ 'fade-in': chartTypeList.includes(6), }">
        <div class="chart_type_box_six flex_center flex_column color_fff cursor "
          :class="{ 'animate-scale-six-child2': !chartTypeList.includes(10) }" v-if="chartTypeList.includes(6)"
          @click="selectGraphChart(10)">
          <img src="@/assets/images/secondIcon3.png" alt="" /> 负极材料
        </div>

      </div>

      <img class="graph_six_img2 cursor animate-scale-six" @mouseenter="graphEnter(6)" @mouseleave="chartLeave"
        @click="selectGraphChart(6)" src="@/assets/images/homeChartBtn.png" alt="">
      <img class="graph_six_img1" :class="chartTypeList.includes(6) ? 'fade-in' : 'fade-out'"
        v-if="chartTypeList.includes(6)" src="@/assets/images/homeChartLine.png" alt="">
    </div>

    <div class="graph_six_children">
      <div :class="{ 'fade-in': chartTypeList.includes(10), }">
        <div class="chart_type_six_child1 flex_center flex_column color_fff cursor"
          :class="{ 'animate-scale-six-child2': !chartTypeList.includes(11) || !chartTypeList.includes(12) }"
          v-if="chartTypeList.includes(10)" @click="selectGraphChartTwo(11)">
          <img src="@/assets/images/secondIcon7.png" alt="" /> 锂电池
        </div>
      </div>

      <img class="graph_six_child1_img1 cursor" :class="chartTypeList.includes(10) ? 'fade-in' : 'fade-out'"
        @click="selectGraphChart(10)" v-if="chartTypeList.includes(10)" src="@/assets/images/homeChartLine.png" alt="">
    </div>

    <div class="graph_six_children">
      <div class="chart_type_six_child2 flex_center flex_column color_fff cursor"
        :class="chartTypeList.includes(11) ? 'fade-in' : 'fade-out'" v-if="chartTypeList.includes(11)">
        <img src="@/assets/images/secondIcon8.png" alt="" /> 手机数码
      </div>
      <img class="graph_six_child2_img1 cursor" :class="chartTypeList.includes(11) ? 'fade-in' : 'fade-out'"
        @click="selectGraphChart(11)" v-if="chartTypeList.includes(11)" src="@/assets/images/homeChartLine.png" alt="">
    </div>

    <div class="graph_six_children">
      <div class="chart_type_six_child3 flex_center flex_column color_fff cursor"
        :class="chartTypeList.includes(12) ? 'fade-in' : 'fade-out'" v-if="chartTypeList.includes(12)">
        <img src="@/assets/images/secondIcon9.png" alt="" /> 电动车
      </div>
      <img class="graph_six_child3_img1 cursor" :class="chartTypeList.includes(12) ? 'fade-in' : 'fade-out'"
        v-if="chartTypeList.includes(12)" @click="selectGraphChart(12)" src="@/assets/images/homeChartLine.png" alt="">
    </div>

    <div class="graph_seven_box">
      <div :class="{ 'fade-in': chartTypeList.includes(7) }">
        <div class="chart_type_box_seven flex_center flex_column color_fff cursor"
          :class="{ 'animate-scale-six-child2': !chartTypeList.includes(8) }" v-if="chartTypeList.includes(7)"
          @click="selectGraphChart(8)">
          <img src="@/assets/images/secondIcon4.png" alt="" /> 预焙阳极
        </div>
      </div>

      <img class="graph_seven_img2 cursor animate-scale-seven" @click="selectGraphChart(7)"
        src="@/assets/images/homeChartBtn.png" alt="">
      <img class="graph_seven_img1" :class="chartTypeList.includes(7) ? 'fade-in' : 'fade-out'"
        v-if="chartTypeList.includes(7)" src="@/assets/images/homeChartLine.png" alt="">
    </div>

    <div class="graph_seven_children">
      <div :class="{ 'fade-in': chartTypeList.includes(8) }">
        <div class="chart_type_seven_child flex_center flex_column color_fff cursor"
          :class="{ 'animate-scale-six-child2': !chartTypeList.includes(9) }" v-if="chartTypeList.includes(8)"
          @click="selectGraphChart(9)">
          <img src="@/assets/images/secondIcon5.png" alt="" /> 电解铝
        </div>
      </div>

      <img class="graph_seven_child_img1 cursor" :class="chartTypeList.includes(8) ? 'fade-in' : 'fade-out'"
        v-if="chartTypeList.includes(8)" @click="selectGraphChart(8)" src="@/assets/images/homeChartLine.png" alt="">
    </div>

    <div class="graph_seven_children">
      <div class="chart_type_seven_child2 flex_center flex_column color_fff cursor"
        :class="chartTypeList.includes(9) ? 'fade-in' : 'fade-out'" v-if="chartTypeList.includes(9)">
        <img src="@/assets/images/secondIcon6.png" alt="" /> 铝制品
      </div>
      <img class="graph_seven_child2_img1 cursor" :class="chartTypeList.includes(9) ? 'fade-in' : 'fade-out'"
        v-if="chartTypeList.includes(9)" @click="selectGraphChart(9)" src="@/assets/images/homeChartLine.png" alt="">
    </div>
  </div>
</template>
<script>
import { topInfo, industryIntroduce, industryDevelopment, homeArticleList, industryChronicle, diagramList } from "@/utils/homeApi";
// @ is an alias to /src

export default {
  name: "Graph",
  components: {
  },
  data() {
    return {
      chartType: 0,
      chartTypeTwo: 0,
      chartTypeList: [4, 5, 6, 7, 8, 9, 10, 11, 12],
      isAnimating: false,
      animationInterval: null
    };
  },
  mounted() {
    this.startAnimationInterval();
  },
  beforeUnmount() {
    clearInterval(this.animationInterval);
  },
  methods: {
    startAnimationInterval() {
      this.animationInterval = setInterval(() => {
        this.isAnimating = true;
      }, 5000); // 每 3 秒执行一次动画
    },
    handleAnimationEnd() {
      this.isAnimating = false;
    },
    // 锂电池点击方法
    selectGraphChartTwo() {
      if (this.chartTypeList.includes(11) && this.chartTypeList.includes(12)) {
        this.selectGraphChart(11);
        this.selectGraphChart(12);
      } else if (this.chartTypeList.includes(11)) {
        this.selectGraphChart(11);
      } else if (this.chartTypeList.includes(12)) {
        this.selectGraphChart(12);
      } else {
        this.selectGraphChart(11);
        this.selectGraphChart(12);
      }


    },
    // 除锂电池之外的点击方法
    selectGraphChart(type) {
      if (this.chartTypeList.includes(type)) {
        let index = this.chartTypeList.indexOf(type);
        this.chartTypeList.splice(index, 1);

        // 预焙阳极分支---子集收起
        if (type == 8) {
          let index = this.chartTypeList.indexOf(9);
          if (index >= 0) {
            this.chartTypeList.splice(index, 1);
          }
        }

        if (type == 7) {
          let index1 = this.chartTypeList.indexOf(8);
          if (index1 >= 0) {
            this.chartTypeList.splice(index1, 1);
          }

          let index2 = this.chartTypeList.indexOf(9);
          if (index2 >= 0) {
            this.chartTypeList.splice(index2, 1);
          }
        }

        // 负极材料---子集收起
        if (type == 10) {
          let index1 = this.chartTypeList.indexOf(11);
          if (index1 >= 0) {
            this.chartTypeList.splice(index1, 1);
          }

          let index2 = this.chartTypeList.indexOf(12);
          if (index2 >= 0) {
            this.chartTypeList.splice(index2, 1);
          }
        }

        if (type == 6) {
          let index3 = this.chartTypeList.indexOf(10);
          if (index3 >= 0) {
            this.chartTypeList.splice(index3, 1);
          }
          let index1 = this.chartTypeList.indexOf(11);
          if (index1 >= 0) {
            this.chartTypeList.splice(index1, 1);
          }

          let index2 = this.chartTypeList.indexOf(12);
          if (index2 >= 0) {
            this.chartTypeList.splice(index2, 1);
          }
        }
      } else {
        this.chartTypeList.push(type);
        // 预焙阳极分支---子集展开
        if (type == 8) {
          this.chartTypeList.push(9);
        }

        if (type == 7) {
          this.chartTypeList.push(8);
          this.chartTypeList.push(9);
        }

        // 负极材料---子集展开
        if (type == 10) {
          this.chartTypeList.push(11);
          this.chartTypeList.push(12);
        }

        if (type == 6) {
          this.chartTypeList.push(10);
          this.chartTypeList.push(11);
          this.chartTypeList.push(12);
        }
      }
    },
    graphEnter(type) {
      // this.chartType = type;
    },
    chartLeave() {
      // this.chartType = 0;
      // this.chartTypeTwo = 0;
    },

  },
};
</script>
<style lang="scss" scoped>
.two_graph_main {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  margin-top: -50px;

}

.two_graph_bg {
  position: absolute;
  top: 45px;
  left: 48px;

  img {
    object-fit: cover;
    width: 727px;
    height: 455px;
  }
}


.graph_one_box {
  // padding-top: 25px;
  // padding-left: 162px;
}

.chart_type_box2 {
  position: absolute;
  top: 140px;
  left: 255px;
  z-index: 1;
  width: 60px;
  height: 60px;
  border-radius: 50%;

  img {
    width: 60px;
    height: 60px;
    object-fit: cover;
    opacity: 0.8;
  }
}

.chart_type_box {
  position: absolute;
  top: 0px;
  left: 242px;
  z-index: 1;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: url("@/assets/images/chartTypeBg.png") center no-repeat;
  background-size: 100% 100%;
  font-size: 16px;
}

.graph_one_img1 {
  width: 150px;
  height: 70px;
  position: absolute;
  transform: rotate(-63deg);
  top: 120px;
  left: 212px;
}

.graph_one_img2 {
  position: absolute;
  z-index: 1;
  transform: rotate(118deg);
  top: 223px;
  left: 273px;
}

.chart_type_box_two2 {
  position: absolute;
  top: 470px;
  left: 400px;
  z-index: 1;
  width: 60px;
  height: 60px;
  border-radius: 50%;

  img {
    width: 60px;
    height: 60px;
    object-fit: cover;
    opacity: 0.8;
  }
}

.chart_type_box_two {
  position: absolute;
  top: 537px;
  left: 460px;
  z-index: 1;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: url("@/assets/images/chartTypeBg.png") center no-repeat;
  background-size: 100% 100%;
  font-size: 16px;
}

.graph_two_img1 {
  position: absolute;
  width: 150px;
  height: 70px;
  transform: rotate(70deg);
  top: 480px;
  left: 360px;
}

.graph_two_img2 {
  position: absolute;
  z-index: 1;
  transform: rotate(-117deg);
  top: 445px;
  left: 373px;
}

.chart_type_box_three2 {
  position: absolute;
  top: 420px;
  left: 60px;
  z-index: 1;
  width: 60px;
  height: 60px;
  border-radius: 50%;

  img {
    width: 60px;
    height: 60px;
    object-fit: cover;
    opacity: 0.8;
  }
}

.chart_type_box_three {
  position: absolute;
  top: 483px;
  left: -80px;
  z-index: 1;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: url("@/assets/images/chartTypeBg.png") center no-repeat;
  background-size: 100% 100%;
  font-size: 16px;
}

.graph_three_img1 {
  position: absolute;
  transform: rotate(173deg);
  top: 433px;
  left: -25px;
}

.graph_three_img2 {
  position: absolute;
  z-index: 1;
  transform: rotate(2deg);
  top: 417px;
  left: 145px;
}

.chart_type_box_four {
  position: absolute;
  top: 555px;
  left: 630px;
  z-index: 1;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: url("@/assets/images/secondNodeBg.png") center no-repeat;
  background-size: 100% 100%;
  font-size: 16px;
}

.chart_type_box_four img {
  width: 50px;
  height: 50px;
  object-fit: cover;
}

.graph_four_img1 {
  position: absolute;
  transform: rotate(102deg);
  width: 100px;
  height: 40px;
  top: 500px;
  left: 623px;
}

.graph_four_img2 {
  position: absolute;
  z-index: 1;
  transform: rotate(-80deg);
  top: 461px;
  left: 659px;
}

.chart_type_box_five {
  position: absolute;
  top: 0px;
  left: 420px;
  z-index: 1;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: url("@/assets/images/secondNodeBg.png") center no-repeat;
  background-size: 100% 100%;
  font-size: 16px;
}

.chart_type_box_five img {
  width: 50px;
  height: 50px;
  object-fit: cover;
}

.graph_five_img1 {
  position: absolute;
  transform: rotate(-98deg);
  width: 150px;
  height: 60px;
  top: 135px;
  left: 461px;
}

.graph_five_img2 {
  position: absolute;
  z-index: 1;
  top: 220px;
  left: 563px;
}

.chart_type_box_six {
  position: absolute;
  top: 98px;
  left: 950px;
  z-index: 1;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: url("@/assets/images/secondNodeBg.png") center no-repeat;
  background-size: 100% 100%;
  font-size: 16px;
}

.chart_type_box_six img {
  width: 50px;
  height: 50px;
  object-fit: cover;
}

.graph_six_img1 {
  position: absolute;
  transform: rotate(-3deg);
  width: 250px;
  height: 100px;
  top: 173px;
  left: 745px;
}

.graph_six_img2 {
  position: absolute;
  z-index: 1;
  transform: rotate(-195deg);
  top: 265px;
  left: 743px;
}

.chart_type_six_child1 {
  position: absolute;
  top: 33px;
  left: 870px;
  z-index: 1;
  width: 63px;
  height: 63px;
  background: #102334;
  border-radius: 50%;
  border: 1px solid #16EEF1;
  font-size: 12px;
}

.chart_type_six_child1 img {
  width: 33px;
  height: 20px;
  object-fit: cover;
}

.graph_six_child1_img1 {
  position: absolute;
  transform: rotate(-120deg);
  width: 130px;
  height: 50px;
  top: 87px;
  left: 898px;
}

.chart_type_six_child2 {
  position: absolute;
  top: -50px;
  left: 735px;
  z-index: 1;
  width: 63px;
  height: 63px;
  background: #102334;
  border-radius: 50%;
  border: 1px solid #16EEF1;
  font-size: 12px;
}

.chart_type_six_child2 img {
  width: 33px;
  height: 20px;
  object-fit: cover;
}

.graph_six_child2_img1 {
  position: absolute;
  transform: rotate(-129deg);
  width: 130px;
  height: 50px;
  top: 0px;
  left: 775px;
}

.chart_type_six_child3 {
  position: absolute;
  top: 60px;
  left: 680px;
  z-index: 1;
  width: 63px;
  height: 63px;
  background: #102334;
  border-radius: 50%;
  border: 1px solid #16EEF1;
  font-size: 12px;
}

.chart_type_six_child3 img {
  width: 33px;
  height: 20px;
  object-fit: cover;
}

.graph_six_child3_img1 {
  position: absolute;
  transform: rotate(-167deg);
  width: 150px;
  height: 60px;
  top: 50px;
  left: 745px;
}

.chart_type_box_seven {
  position: absolute;
  top: 370px;
  left: 865px;
  z-index: 1;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: url("@/assets/images/secondNodeBg.png") center no-repeat;
  background-size: 100% 100%;
  font-size: 16px;
}

.chart_type_box_seven img {
  width: 50px;
  height: 50px;
  object-fit: cover;
}

.graph_seven_img1 {
  position: absolute;
  transform: rotate(38deg);
  width: 130px;
  height: 50px;
  top: 385px;
  left: 760px;
}

.graph_seven_img2 {
  position: absolute;
  z-index: 1;
  transform: rotate(-135deg);
  top: 378px;
  left: 755px;
}

.chart_type_seven_child {
  position: absolute;
  top: 415px;
  left: 1045px;
  z-index: 1;
  width: 63px;
  height: 63px;
  background: #102334;
  border-radius: 50%;
  border: 1px solid #16EEF1;
  font-size: 12px;
}

.chart_type_seven_child img {
  width: 33px;
  height: 20px;
  object-fit: cover;
}

.graph_seven_child_img1 {
  position: absolute;
  transform: rotate(22deg);
  width: 130px;
  height: 50px;
  top: 425px;
  left: 945px;
}

.chart_type_seven_child2 {
  position: absolute;
  top: 365px;
  left: 1150px;
  z-index: 1;
  width: 63px;
  height: 63px;
  background: #102334;
  border-radius: 50%;
  border: 1px solid #16EEF1;
  font-size: 12px;
}

.chart_type_seven_child2 img {
  width: 33px;
  height: 20px;
  object-fit: cover;
}

.graph_seven_child2_img1 {
  position: absolute;
  transform: rotate(-12deg);
  width: 130px;
  height: 50px;
  top: 407px;
  left: 1060px;
}

.fade-in {
  animation: fadeIn 2s;
  /* 渐入动画，持续2秒 */
}

.fade-out {
  animation: fadeOut 2s;
  /* 渐出动画，持续2秒 */
}

/* 在你的组件的<style>部分或者全局样式文件中 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.animate-scale-one {
  animation: scaleAnimation_one 1s infinite alternate;
}

@keyframes scaleAnimation_one {
  from {
    transform: rotate(118deg) scale(1);
  }

  to {
    transform: rotate(118deg) scale(1.2);
  }
}

.animate-scale-two {
  animation: scaleAnimation_two 1s infinite alternate;
}

@keyframes scaleAnimation_two {
  from {
    transform: rotate(-117deg) scale(1);
  }

  to {
    transform: rotate(-117deg) scale(1.2);
  }
}

.animate-scale-three {
  animation: scaleAnimation_three 1s infinite alternate;
}

@keyframes scaleAnimation_three {
  from {
    transform: rotate(-0deg) scale(1);
  }

  to {
    transform: rotate(-0deg) scale(1.2);
  }
}

.animate-scale-four {
  animation: scaleAnimation4 1s infinite alternate;
}

@keyframes scaleAnimation4 {
  from {
    transform: rotate(-80deg) scale(1);
  }

  to {
    transform: rotate(-80deg) scale(1.2);
  }
}

.animate-scale-five {
  animation: scaleAnimation5 1s infinite alternate;
}

@keyframes scaleAnimation5 {
  from {
    transform: rotate(83deg) scale(1);
  }

  to {
    transform: rotate(83deg) scale(1.2);
  }
}

.animate-scale-six {
  animation: scaleAnimation6 1s infinite alternate;
}

@keyframes scaleAnimation6 {
  from {
    transform: rotate(-188deg) scale(1);
  }

  to {
    transform: rotate(-188deg) scale(1.2);
  }
}

.animate-scale-six-child1 {
  animation: scaleAnimation10 1s infinite alternate;
}

@keyframes scaleAnimation10 {
  from {
    transform: rotate(55deg) scale(0.8);
  }

  to {
    transform: rotate(55deg) scale(1);
  }
}

.animate-scale-six-child2 {
  animation: scaleAnimation11 1s infinite alternate;
}

@keyframes scaleAnimation11 {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(1.05);
  }
}

.animate-scale-six-child3 {
  animation: scaleAnimation12 1s infinite alternate;
}

@keyframes scaleAnimation12 {
  from {
    transform: rotate(10deg) scale(0.6);
  }

  to {
    transform: rotate(10deg) scale(0.8);
  }
}

.animate-scale-seven {
  animation: scaleAnimation7 1s infinite alternate;
}

@keyframes scaleAnimation7 {
  from {
    transform: rotate(-135deg) scale(1);
  }

  to {
    transform: rotate(-135deg) scale(1.2);
  }
}

.animate-scale-seven-child1 {
  animation: scaleAnimation8 1s infinite alternate;
}

@keyframes scaleAnimation8 {
  from {
    transform: rotate(-148deg) scale(0.8);
  }

  to {
    transform: rotate(-148deg) scale(1);
  }
}

.animate-scale-seven-child2 {
  animation: scaleAnimation9 1s infinite alternate;
}

@keyframes scaleAnimation9 {
  from {
    transform: rotate(-178deg) scale(0.6);
  }

  to {
    transform: rotate(-178deg) scale(0.8);
  }
}

.animate-scale-seven-small-child {
  animation: scaleAnimation13 2s;
}

@keyframes scaleAnimation13 {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}
</style>
